
/*
play-dashboard.component.html
Golfhubber
Created by Chetan Baghel on 28/06/2021.
Copyright © 2021 Golfhubber Ltd. All rights reserved.
*/
// Angular
import { Component, OnInit } from "@angular/core";
// Models
import { Tournament } from "./../../models/tournament";
// Services

import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { OAuthService } from "./../../services/o-auth";
import { Club } from "./../../models/club";
import { AngularFireDatabase } from "angularfire2/database";
import { ElasticService } from "app/services/elastic";

@Component({
  templateUrl: "./play-dashboard.component.html",
})
export class PlayDashboardComponent implements OnInit {
  public club: any;
  public tournamentCount = 0;
  public multiRoundCount = 0;
  constructor(
    private apiService: ApiService,
    private elasticService: ElasticService,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase
  ) {}

  async ngOnInit() {
    this.club = this.oAuthService.getClub();
    await this.getTournament();
    this.getMultiRoundTournament();
  }

  getTournament() {
    let promise = new Promise((resolve, reject) => {
      let queryParams = {};

      queryParams = {
        index: "tournaments",
        type: "tournament",
        "body/sort/startDate/order": `desc`,
        
      };
      console.log(this.club);

      if (this.club.type == 1) {
        queryParams[
          "body/query/bool/must/0/match/es_cid"
        ] = this.club.cid.split("-").join("");
      }
      if (this.club.type == 6 || this.club.type == 7) {
        queryParams["body/query/match/uid"] = this.club.cid;
      }
      // queryParams["body/query/match/uid"] = this.club.cid;
      this.elasticService.search(queryParams).then((result) => {
        console.log(result);

        if (result) {
          this.tournamentCount = result.total;

          resolve();
        } else {
          resolve();
        }
      });
    });
    return promise;
  }

  getMultiRoundTournament() {
    this.fireDatabase.database.ref(`/multi-round/`).once("value", result => {
      lodash.forEach(result.val(), (element, key) => {
        if (element.isDeleted == false) {
          this.multiRoundCount = this.multiRoundCount + 1;
        }
      });
    });
  }
}
